import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { Switch, List, Input, Toast, Modal } from 'antd-mobile';
import axiosInstance from '../axiosInstance';
import './Settings.css';

const Settings = () => {
  const navigate = useNavigate();


  const handleLogout = () => {
    localStorage.removeItem('access_token');
    Toast.show({ icon: 'success', content: 'Logout successful' });
    navigate('/login');
  };
  const [botEnabled, setBotEnabled] = useState(false);



  const handleChangePassword = async (values) => {
    try {
      await axiosInstance.put('/api/users/change-password', {
        new_password: values.newPassword,
      });
      Toast.show({ icon: 'success', content: 'Password changed successfully' });
    } catch (error) {
      Toast.show({ icon: 'fail', content: 'Failed to change password' });
      console.error('Change password error:', error);
    }
  };




  const showChangePasswordModal = () => {
    Modal.show({
      title: 'Change Password',
      closeOnMaskClick: true,
      content: (
        <Input
          type="password"
          placeholder="New Password"
          onEnterPress={(value) => {
            Modal.clear();
            handleChangePassword({ newPassword: value });
          }}
        />
      ),
      actions: [
        {
          key: 'cancel',
          text: 'Cancel',
          onClick: () => {
            Modal.clear();
          },
        },
        {
          key: 'confirm',
          text: 'Confirm',
          onClick: (value) => {
            Modal.clear();
            handleChangePassword({ newPassword: value });
          },
        },
      ],
    });
  };

  return (
    <List>
      <List.Item onClick={showChangePasswordModal}>
        Change Password
      </List.Item>
      <List.Item onClick={handleLogout} style={{ color: 'red' }}>
        Logout
      </List.Item>
      <List.Item>

      </List.Item>
    </List>
  );
};

export default Settings;